import { Component, OnInit, OnDestroy } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { LoginService } from 'src/app/core/services/login.service';
import { LogoutService } from 'src/app/core/services/logout.service';
import { DashboardService } from 'src/app/shared/services/dashboard.service';
import { CustomerDetailsService } from 'src/app/core';
import { PopUpId } from 'src/app/core/models/enum/PopUpId.enum';

import { EventTypes } from 'src/app/core/models/enum/EventTypes.enum';
import { DialogBoxComponent } from 'src/app/shared/components/dialog-box/dialog-box.component';

const moment = require('moment');

@Component({
  selector: 'app-nav-big',
  templateUrl: './nav-big.component.html',
  styleUrls: ['./nav-big.component.less'],
  standalone: false
})
export class NavBigComponent implements OnInit, OnDestroy {
  public date: Date;
  public userFirstName: string;
  public shareLocation: boolean;
  public loggedIn: boolean;
  public firstLink = 'Master Data Management';
  public eventTypes: typeof EventTypes = EventTypes;
  public vinNumber = '';
  public key;
  public showVinNoErrMsg = false;
  public popUpId: typeof PopUpId = PopUpId;
  public navSubscription: any;
  public ctiUrl: SafeUrl;
  public userId: any;
  public crmAuthKey: any;
  public crmApiUrl: any;
  public loggedInUserData: any;
  public searchKeyVal = '';
  public currentNav: any;
  public criticalEvents: any;

  public userData = {
    firstName: '',
    lastName: '',
    lastLogon: '',
    emailId: '',
    envConfig: {}
  };
  constructor(
    public router: Router,
    private loginSvc: LoginService,
    public ngBModalService: NgbModal,
    private logoutService: LogoutService,
    private dashboardService: DashboardService,
    private customerDetailsService: CustomerDetailsService,
    private sanitizer: DomSanitizer,
    private db: AngularFirestore
  ) {


    // // CTI iframe Listener
    // window.addEventListener('message', (event) => {
    //   console.log('cti events', event);
    //   if (event.data.callType === 'connect') {
    //     if (event.data.vinNumber === '0' || event.data.vinNumber === '') {
    //       this.searchKeyVal = event.data.phoneNumber;
    //       this.search();
    //       // localStorage.setItem('vinNumber', event.data.phoneNumber);
    //       // this.router.navigate(['/dashboard/search-results']);
    //       // this.router.navigate(['/dashboard/customerMapIntegration']);

    //     } else {
    //       //   this.searchKeyVal = event.data.phoneNumber;
    //       //   this.search();
    //     }

    //     // this.openModal('CTI Dialing', 'apiError', 'Call Connected');
    //   } else if (event.data.callType === 'disconnect') {
    //     //this.openModal('CTI Dialing', 'apiError', 'Call Disconnected');
    //     // if (event.data.vinNumber) {
    //     //   localStorage.setItem('vinNumber', event.data.vinNumber);
    //     //   this.router.navigate(['/dashboard/customerMapIntegration']);
    //     // }
    //   }
    // });
  }

  ngOnInit() {
    this.dashboardService.pageName = localStorage.getItem('pageName');
    // console.log('before')
    this.getLoggedInUsers();
    // console.log('after')
    setInterval(() => {
      this.date = new Date();
    }, 1000);
 
    this.currentNav = localStorage.getItem('pageName');
    // this.userId = localStorage.getItem('userId');
    this.userFirstName = localStorage.getItem('userFirstName') || '';
    // this.loggedInUserData = JSON.parse(localStorage.getItem('loggedInUserData'));
    // this.crmApiUrl = this.loggedInUserData.envConfig.crmUrl;
    // this.crmAuthKey = this.loggedInUserData.envConfig.crmAuthKey;
    this.loginSvc.currentMessage.subscribe(
      loginStatus => (this.loggedIn = loginStatus)
    );

    if (this.router.url.indexOf('/login') > -1) {
      this.loggedIn = false;
    }

    this.navSubscription = this.dashboardService.dashbaordSourceObservable.subscribe((data: any) => {
      if (data.callmeClick === true) {
        this.searchKeyVal = data.phone;
        this.search();
      }

      if (data.callbackClick === true) {
        this.searchKeyVal = data.phone;
        this.search();
      }

      if (data.getCallMeDetails === true) {
        console.log('call me 2nd');
        this.callmeOption();
      }

      if (data.getCallBackOption === true) {
        this.getCallBackOption();
      }

      if (data.pageName !== null || data.pageName !== undefined) {
        this.currentNav = data.pageName;
      }

      if (data.previousPage === true) {
        this.currentNav = localStorage.getItem('previousPageName');
      }
    });
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    if(this.userId && this.userId !==undefined && this.userId !=='') {
      let checkEvent = false;
      this.criticalEvents = this.db.collection('criticalEvents').doc(this.userId).collection('vinNumber').valueChanges().subscribe(events => {
        console.log('Change in Firebase ==>>', events)
        if(!checkEvent) {
          checkEvent = true;
        } else {
          if(events && events.length>0) {
            events.sort((a,b) =>  {
              if (a.timeStamp > b.timeStamp) return -1;
              if (a.timeStamp < b.timeStamp) return 1;
              return 0;
            });
            let data = events[0];
            localStorage.setItem('vinNumber', data.vinNumber);
            let url = window.location.pathname.split('/');
            if (localStorage.getItem('pageName') === 'search-results' && url[2] === 'customerMapIntegration') {
              this.router.navigate(['/dashboard/customerMapIntegration']).then(() => {
                window.location.reload();
              });
              this.dashboardService.dashboardEvent({
                invokedSearch: true
              });
            } else {
              this.router.navigate(['/dashboard/customerMapIntegration']);
              this.dashboardService.dashboardEvent({
                invokedSearch: true
              });
            }
            this.router.navigate(['/dashboard/customerMapIntegration']);
            this.dashboardService.dashboardEvent({
              invokedSearch: true
            });            
          }
        }               
      })
    }
    
  }



  ngOnDestroy() {
    this.navSubscription.unsubscribe();  
  }

  omit(event) {
    this.key = event.charCode;
    return ((this.key > 64 && this.key < 91) || (this.key > 96 && this.key < 123) || (this.key >= 48 && this.key <= 57));
  }
  getLoggedInUsers() {
    const userLocalData: any = JSON.parse(localStorage.getItem('loggedInUserData'));
    //console.log(userLocalData)
    if (userLocalData !== null) {
      this.userData.firstName = userLocalData.firstName;
      this.userData.lastName = userLocalData.lastName;
      this.crmApiUrl = userLocalData.envConfig.crmUrl;
      this.crmAuthKey = userLocalData.envConfig.crmAuthKey;
      this.userId = userLocalData.deliteId;
      //console.log(this.crmApiUrl, this.crmAuthKey, this.userId)
      this.userData.lastLogon = userLocalData.lastLoginTime == null ? 'NA' : userLocalData.lastLoginTime;
      this.ctiUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${userLocalData.envConfig.ctiUrl}/czhandler/cti_handler.php?e=${userLocalData.deliteId}${userLocalData.emailId}`);
    }
  }

  moveToOwnershipTransfer(page) {
    this.currentNav = page;
    localStorage.setItem('pageName', page);
    const startDate = moment(new Date()).startOf('day').format();
    const endDate = moment(new Date()).endOf('day').format();
    this.dashboardService.dashboardEvent({
      proceed: true,
      startDate,
      endDate,
      pageName: localStorage.getItem('pageName')
    });
    this.router.navigate([`/ownership-transfer/${page}`]);
  }

  moveToDeviceMapping(page) {
    this.currentNav = page;
    localStorage.setItem('pageName', page);
    const startDate = moment(new Date()).startOf('day').format();
    const endDate = moment(new Date()).endOf('day').format();
    this.dashboardService.dashboardEvent({
      proceed: true,
      startDate,
      endDate,
      pageName: localStorage.getItem('pageName')
    });
    this.router.navigate([`/device-mapping/${page}`]);
  }

  moveToSearchOldVin(page) {
    this.currentNav = page;
    localStorage.setItem('pageName', page);
    const startDate = moment(new Date()).startOf('day').format();
    const endDate = moment(new Date()).endOf('day').format();
    this.dashboardService.dashboardEvent({
      proceed: true,
      startDate,
      endDate,
      pageName: localStorage.getItem('pageName')
    });
    this.router.navigate([`/search-old-vin/${page}`]);
  }
  moveToSearchLetData(page) {
    this.currentNav = page;
    localStorage.setItem('pageName', page);
    const startDate = moment(new Date()).startOf('day').format();
    const endDate = moment(new Date()).endOf('day').format();
    this.dashboardService.dashboardEvent({
      proceed: true,
      startDate,
      endDate,
      pageName: localStorage.getItem('pageName')
    });
    this.router.navigate([`/search-letData/${page}`]);
  }
  moveToDeleteGuestUser(page) {
    this.currentNav = page;
    localStorage.setItem('pageName', page);
    const startDate = moment(new Date()).startOf('day').format();
    const endDate = moment(new Date()).endOf('day').format();
    this.dashboardService.dashboardEvent({
      proceed: true,
      startDate,
      endDate,
      pageName: localStorage.getItem('pageName')
    });
    this.router.navigate([`/delete-guestUser/${page}`]);
  }

  moveToDashboard(page) {
    this.router.navigate(['/dashboard/criticalDashboard']);
    if (page === 'mCallCount') {
      localStorage.setItem('pageName', this.eventTypes.MCALL_COUNT);
    } else {
      localStorage.setItem('pageName', page);
    }
    this.currentNav = page;
    const startDate = moment(new Date()).startOf('day').format();
    const endDate = moment(new Date()).endOf('day').format();
    this.dashboardService.dashboardEvent({
      proceed: true,
      startDate,
      endDate,
      pageName: localStorage.getItem('pageName')
    });
  }

  goHome() {
    this.currentNav = 'home';
    this.router.navigate(['/dashboard/home']);
  }

  changePassword() {
    this.router.navigate(['/dashboard/changePassword']);
  }


  /**
   * API call to get the list based on search key
   */
  search() {
    const formData = {
      vinNumber: this.searchKeyVal.toUpperCase() !== '' ? this.searchKeyVal.toUpperCase() : localStorage.getItem('vinNumber').toUpperCase()
    };

    this.customerDetailsService.seachKey = this.searchKeyVal;
    localStorage.setItem('searchKey', this.searchKeyVal);
    localStorage.setItem('pageName', this.eventTypes.SEARCHRESULTS);
    this.customerDetailsService.getCustomeList(formData).subscribe(
      (result) => {
        if (result.status.status) {
          if (result && result.data && result.data.vehicleList) {
            this.customerDetailsService.searchResults = result.data.vehicleList;
            if (result.data.vehicleList.length === 1) {
              localStorage.setItem('vinNumber', result.data.vehicleList[0].vinNumber);
              let url = window.location.pathname.split('/');
              if(localStorage.getItem('pageName') === 'search-results' && url[2] === 'customerMapIntegration') {
                this.router.navigate(['/dashboard/customerMapIntegration']).then(() => {
                  window.location.reload();
                });
                this.dashboardService.dashboardEvent({
                  invokedSearch: true
                });
              } else {
                this.router.navigate(['/dashboard/customerMapIntegration']);
                this.dashboardService.dashboardEvent({
                  invokedSearch: true
                });
              }      
            } else {
              this.router.navigate(['/dashboard/search-results']);
            }
          } else {
            console.log('no data');
            this.router.navigate(['/dashboard/search-results']);
          }

          this.dashboardService.dashboardEvent({
            search: true
          });
        } else {
          if (result.status.statusCode === 50008) {
            this.dashboardService.backToLogin();
          } else {
            console.log('no data');
            this.customerDetailsService.searchResults = [];
            this.router.navigate(['/dashboard/search-results']);
            this.dashboardService.dashboardEvent({
              search: true
            });
          }
        }

      }, (error) => {
        console.error('Error at Customer Api ...', error);
        if (error.status === 401 || error.status === 402) {
          if (error.error && error.error.status && error.error.status.message) {
            this.dashboardService.unauthorizedLogoutMsg = error.error.status.message;
          } else {
            this.dashboardService.unauthorizedLogoutMsg = 'Something Went wrong, Please Login again to continue';
          }
          this.dashboardService.backToLogin();
        } else {
          this.dashboardService.openModal('Error', PopUpId.ERRMSGPOP, error.statusText);
        }
      });

    console.log('vin number', this.searchKeyVal);
    this.showVinNoErrMsg = false;
    // tslint:disable-next-line: triple-equals
    // if (this.searchKeyVal != '') {
    //   localStorage.setItem('vinNumber', this.searchKeyVal);
    //   this.router.navigate(['/dashboard/customerMapIntegration']);
    // } else {
    //   this.showVinNoErrMsg = true;
    // }

    this.searchKeyVal = '';
  }

  isUserLoggedIn() {
    return localStorage.getItem('loggedInUserData') && localStorage.getItem('refreshToken') ? true : false;
  }

  logout() {
    this.logoutService.logoutSvc().subscribe((data) => {
      if (data.status.status) {
        this.loggedIn = false;
        localStorage.removeItem('userId');
        localStorage.removeItem('userPassword');
        localStorage.removeItem('loggedInUserData');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('vehRegNumber');
        localStorage.removeItem('previousPageName');
        localStorage.removeItem('dealerCode');
        localStorage.removeItem('eventId');
        localStorage.removeItem('selectedVinNumber');
        localStorage.removeItem('pages');
        localStorage.removeItem('productOwnId');
        localStorage.removeItem('searchKey');
        localStorage.removeItem('userFirstName');
        localStorage.removeItem('vinNumber');
        localStorage.removeItem('alert');
        this.criticalEvents.unsubscribe();
        this.router.navigate(['/login'], { replaceUrl: true });
      }
    }, (error) => {
      if (error.status === 401 || error.status === 402) {
        if (error.error && error.error.status && error.error.status.message) {
          this.dashboardService.unauthorizedLogoutMsg = error.error.status.message;
        } else {
          this.dashboardService.unauthorizedLogoutMsg = 'Something Went wrong, Please Login again to continue';
        }
        this.router.navigate(['/login'], { replaceUrl: true });
      } else {
        this.openModal('Logout', 'apiError', error);
      }
    });

  }

  openModal(heading, id, content) {
    if (id === 'search') {
      localStorage.setItem('pageName', 'search');
    }
    const modalConfig = {
      heading,
      popupId: id,
      popUpContent: content
    };
    const modalRef = this.ngBModalService.open(DialogBoxComponent, {
      centered: true,
      keyboard: false,
      backdrop: 'static'
    });
    modalRef.componentInstance.modalConfig = modalConfig;
  }

  callmeOption() {
    console.log('call me third');
    // API call to get the list based on search key
    const formData = {};

    this.customerDetailsService.callmeList(formData).subscribe(
      (result) => {
        if (result.status.status === true) {
          if (result.data && result.data.callMeDetails) {
            this.customerDetailsService.callmeResults = result.data.callMeDetails;
            if (result.data.callMeDetails.length > 0) {
              this.router.navigate(['/dashboard/call-me-lists']);
            } else {
              this.openModal('Call Me', 'apiError', '');
            }
          }
        } else if (result.status.status === false) {
          this.openModal('Call Me', 'apiError', result.status.message);
        }
      }, error => {
        if (error.status === 401 || error.status === 402) {
          if (error.error && error.error.status && error.error.status.message) {
            this.dashboardService.unauthorizedLogoutMsg = error.error.status.message;
          } else {
            this.dashboardService.unauthorizedLogoutMsg = 'Something Went wrong, Please Login again to continue';
          }
          this.dashboardService.backToLogin();
        } else {
          this.openModal('Call Me', 'apiError', error);
        }
        // this.dashboardService.openModal('Error', PopUpId.ERRMSGPOP, 'Unauthorized');
      });
  }

  getCallBackOption() {
    const formData = {};
    this.customerDetailsService.getCallBackOption(formData).subscribe(
      (result) => {
        if (result.status.status === true) {
          if (result.data && result.data.callMeDetails) {
            this.customerDetailsService.callbackResults = result.data.callMeDetails;
            if (result.data.callMeDetails.length > 0) {
              this.router.navigate(['/dashboard/call-back-lists']);
            } else {
              this.openModal('Call Back', 'apiError', '');
            }
          }
        } else if (result.status.status === false) {
          this.openModal('Call Back', 'apiError', result.status.message);
        }
      }, error => {
        if (error.status === 401 || error.status === 402) {
          if (error.error && error.error.status && error.error.status.message) {
            this.dashboardService.unauthorizedLogoutMsg = error.error.status.message;
          } else {
            this.dashboardService.unauthorizedLogoutMsg = 'Something Went wrong, Please Login again to continue';
          }
          this.dashboardService.backToLogin();
        } else {
          this.openModal('Call Back', 'apiError', error);
        }
        // this.dashboardService.openModal('Error', PopUpId.ERRMSGPOP, 'Unauthorized');
      });
  }
  bar_div_action() {
    if (document.getElementById('bar_div').style.display === 'none') {
      document.getElementById('bar_div').style.display = 'block';
    } else {
      document.getElementById('bar_div').style.display = 'none';
    }
  }

  listener(event) {

    // console.log('message from iframe', event);
    // if (event.data.callType === 'connect') {
    //   this.openModal('CTI Dialing', 'apiError', 'Call Connected');
    // } else if (event.data.callType === 'disconnect') {
    //   this.openModal('CTI Dialing', 'apiError', 'Call Disconnected');
    // }
    // const spiltData = event.data.split( '|' );
    // if ( spiltData[ 0 ] == 'Accept' ) {
    // if ( spiltData[ 6 ] != '' ) {
    //   document.getElementById( 'crm_frame' ).src = 'http://crm.netmeds.com/index.php?entryPoint=getdatafrommobile&call_no=' + spiltData[ 6 ] + '&phone_no=' + spiltData[ 1 ] + '&agent_id=' + spiltData[ 2 ] + '&host_id=' + spiltData[ 3 ];
    // } else {
    //   document.getElementById( 'crm_frame' ).src = 'http://crm.netmeds.com/index.php?entryPoint=getdatafrommobile&call_no=' + spiltData[ 1 ] + '&phone_no=' + spiltData[ 1 ] + '&agent_id=' + spiltData[ 2 ] + '&host_id=' + spiltData[ 3 ];
    // }
    // document.getElementById( 'bar_div' ).style.display = 'block';
    // }
  }

}
